
import React, { Component } from "react";
import "../../../games/non_timer/blackjack/blackjackIndex.css";


import gsap from "gsap";
import { Howl, Howler } from "howler";

import { connect } from "react-redux";
import CoinBurst from "../../../games/CoinBurst"
import CardsContainer from "./CardsContainer";
import historyCards from "../RussianPoker/UI/resultCards";
// for sounds start

import popupExit from "../../../../../assets/common_imgs/exit_btn.png";
import betchipsnd from "././../../../../../assets/sounds/betoncard.mp3";
import pokerchipsnd from "././../../../../../assets/sounds/pokerchip_snd.mp3";
// import playerWin from "../../../../../assets/sounds/successNew.mp3";
import playerWin from "../../../../../assets/sounds/coinBurstwinSound.mp3";
import selectCard from "../../../../../assets/sounds/selectcard.mp3";
import unselectCard from "../../../../../assets/sounds/unselectcard.mp3";
import betrussiansnd from "././../../../../../assets/sounds/bet.mp3";
// for sounds end


import bjbgPrt from "../../../../../assets/games/blackjack/bjBgPrt.webp";
import bjbgLnds from "../../../../../assets/games/blackjack/bjBgLnds.webp";
import bjbgWnds from "../../../../../assets/games/blackjack/bjBgWnds.webp";

import bjTPrt from "../../../../../assets/games/blackjack/bjTtPrt.webp";
import bjTLnds from "../../../../../assets/games/blackjack/bjTLnds.webp";
import bjTWnds from "../../../../../assets/games/blackjack/bjTWnds.webp";

import dealbtnWds from "../../../../../assets/games/jacksorbetter/betbtn2.png";
import clearbtnWds from "../../../../../assets/games/jacksorbetter/mw_btn_org.png";
import doublebtnWds from "../../../../../assets/games/jacksorbetter/foldbtn2.png";
import splitbtnWds from "../../../../../assets/games/jacksorbetter/buybtn2.png";

import betincerementdecrement from "../../../../../assets/games/russianPoker/betincreament&decreament.png";

import placeBetImg from "../../../../../assets/games/CarebbeanPoker/ante&bet.svg";
import blackjsckDeck from "../../../../../assets/games/tropicalstudpoker/DeckTP.png";

import balanceImg from "../../../../../assets/games/russianPoker/balancewindows.png";
import betImg from "../../../../../assets/games/russianPoker/betwindows.png";
import menuImg from "../../../../../assets/games/jacksorbetter/menu.svg";
import usernameImg from "../../../../../assets/games/russianPoker/userid.png";

import volumeImg from "../../../../../assets/games/russianPoker/Valume.png";
import mutesnds from "../../../../../assets/games/russianPoker/mute_snds.png";
import winImg from "../../../../../assets/games/russianPoker/winnericonwindows.png";



import chip_10 from "../../../../../assets/games/russianPoker/Whitechip.svg";
import chip_25 from "../../../../../assets/games/russianPoker/black.png";
import chip_50 from "../../../../../assets/games/russianPoker/blue.png";
import chip_100 from "../../../../../assets/games/russianPoker/red.png";
import chip_500 from "../../../../../assets/games/russianPoker/yellow.png";
import chip_1000 from "../../../../../assets/games/russianPoker/Purple chip.svg";



const activeMenuOptionStatus = {
    help: "HELP",
    history: "HISTORY"

}

class BlackJack extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isActiveWindowsMode: null,
            isActivePortraitMode: null,
            isActiveLandscapeMode: null,


            count: 0,
            splitCount: 0,
            activeHand: 0,
            dalStdRbetButton: "Deal",
            dalStdRbetButtonButtonNumber: 0,
            dalStdRbetHideShowButton: false,

            clrHitRbetxButton: "Clear",
            clrHitRbetx2ButtonNumber: 0,
            clrHitRbetx2HideShowButton: false,

            doubleHideShowButton: false,
            splitHideShowButton: false,

            betAmount: 0,
            balanceDeductions: 0,
            totalShowBetAmount: 0,
            blackJackWinamount: 0,

            hasInsurance: false,
            insuranceBetAmount: 0,

            activeBalance: Number(props.balance),
            // activeBalance: 1,
            activeMenuOption: false,
            betchipdecreamentbtn: true,
            betchipincrementbtn: false,
            menuOptionContainer: false,
            betChipsStore: [],
            activeMenuOption: activeMenuOptionStatus.help,


            isSoundOn: true,
            isPlayingChip: false,
            chipSound: null,
            playerHand: null,
            isactiveGame: true,




            menuButton: null,
            menuOption: null,
            userContainer: null,
            userIcon: null,
            userName: null,
            balanceContainer: null,
            betseContainer: null,
            winseContainer: null,
            informationButtonWnds: null,
            volumeButtonWnds: null,
            autoholdButton: null,
            autoplayButton: null,
            errorPopupContainer: null,
            userIdContainer: null,
            useIdNumber: null,
            betChipsContainer: null,
            betChipIncrementButton: null,
            betChipDecrementButton: null,
            betImageContainer: null,
            betChipImage: null,
            betChipText: null,
            betButton: null,
            dealDrawButton: null,
            betMaxButton: null,
            splitButton: null,
            betButtonImages: null,
            gameButtonChipText: null,
            CardsContainer: null,
            cardsContainerCover: null,
            payoutContainer: null,
            autoplayactiveRound: null,
            menuOptionContainerCss: null,
            helpMainContainer: null,
            rebet2Button: null,
            minMaxBetLimits: null,

            betPlaceContainer: null,
            betMovingChipContainer: null,
            blackjsckDeck: null,
            betChipStoreContainer: null,
            helpOption: null,
        }

        this.CardsContainer = React.createRef();
        this.winPopupContainer = React.createRef();

        this.clearTimingLeft = [];
        this.chipVal = [
            { src: chip_10, key: 1, label: "10", val: 10, },
            { src: chip_25, key: 1, label: "20", val: 20, },
            { src: chip_50, key: 1, label: "50", val: 50, },
            { src: chip_100, key: 1, label: "100", val: 100, },
            { src: chip_500, key: 1, label: "500", val: 500, },
            { src: chip_1000, key: 1, label: "1000", val: 1000, },

        ];


    }


    initializeChipSound = () => {
        let chipSound = new Howl({
            src: [pokerchipsnd],
            html5: true, // Enable HTML5 Audio for mobile compatibility
        });
        this.setState({
            chipSound,
            isPlayingChip: false
        })
        return chipSound
    }

    playPokerChipSound = (chipSound) => {
        const { isPlayingChip, isSoundOn } = this.state;
        // let currentSound = chipSound;
        // if (isSoundOn) {

        //     if (isPlayingChip && currentSound) {
        //         chipSound.stop();
        //     }
        //     if (!chipSound) {
        //         currentSound = this.initializeChipSound();
        //     }

        //     currentSound.play();
        //     this.setState({
        //         isPlayingChip: true
        //     })
        // }
        if (!isSoundOn)
            return;
        if (isSoundOn) {
            chipSound.stop();
            chipSound.play();
        }

    };




    initializeBetSound = () => {
        try {
            const betSound = new Howl({
                src: [betchipsnd],
                html5: true, // Enable HTML5 Audio for mobile compatibility
            });
            this.setState({
                betSound,
                isPlayingBet: false,
            });
            return betSound;
        } catch (error) {
            console.error("Error initializing bet sound:", error);
            return null;
        }
    };

    playRemainingSounds = (chipSound) => {
        const { isPlayingBet, isSoundOn } = this.state;
        // let currentSound = chipSound;
        // if (isSoundOn) {
        //     currentSound.play();
        // }

        if (!isSoundOn)
            return;
        if (isSoundOn) {
            chipSound.stop();
            chipSound.play();
        }

    };




    initializePlayerWinSound = () => {

        let winSound = new Howl({
            src: [playerWin],
            html5: true,
        });

        return winSound


    }





    componentDidMount() {
        const { childRef } = this.props;
        childRef(this);
        Howler?.mute(false);
        Howler.volume(1);
        Howler.autoUnlock = true;
        document.addEventListener('keydown', this.handleKeyDown);
        window.addEventListener("pageshow", this.resumeAudio);


        console.log("this.props.balance :", this.props.balance)
        document.getElementById('iospopup').style.display = "block";
        this.handleOrientationChange();
        window.addEventListener("resize", this.handleResize);
        this.setState({
            jacksorBetterPayouts: this.props.game_PayoutInfo,
            activeBalance: this.props.balance,
            // activeBalance: 1,
        });

        if (this.props.jrb_chipValues) {
            let newChips = this.props.jrb_chipValues.split(",");
            console.log(newChips);
            console.log(newChips.length, newChips.slice(0, 6), newChips.slice(0, 6).length);
            let lblTxt = "";

            // for (let i = 0; i < newChips.slice(0, 6).length; i++) {
            for (let i = 0; i < newChips.length; i++) {
                if (Number(newChips[i]) >= 1000 && Number(newChips[i]) <= 999999) {
                    lblTxt = "K"
                } else if (Number(newChips[i]) >= 1000000 && Number(newChips[i]) <= 999999999) {
                    lblTxt = "M"
                } else if (Number(newChips[i]) > 999999999) {
                    lblTxt = "B"
                }
                this.chipVal[i].val = Number(newChips[i])
                console.log(this.chipVal[i].val, lblTxt);
                this.checkChipValue(Number(this.chipVal[i].val), lblTxt, i);
            }



        }

        // const winpopupElement = document.getElementById("winpopupBlackjack");
        // winpopupElement.classList.add("winPopupForMptIntl");

        this.showPreviousGameStatus();


        // this.pokerchipsnd = this.initializeChipSound();
        // this.betrussiansnd = new Audio(betrussiansnd);

        // this.betchipsnd = this.initializeBetSound();
        // this.playerWin = this.initializePlayerWinSound();
        this.selectCard = new Howl({ src: [selectCard], html5: false, preload: true });
        this.unselectCard = new Howl({ src: [unselectCard], html5: false, preload: true });
        this.pokerchipsnd = new Howl({ src: [pokerchipsnd], html5: false, preload: true });
        // this.pokerchipsnd = new Audio(pokerchipsnd);
        this.betchipsnd = new Howl({ src: [betchipsnd], html5: false, preload: true });
        this.playerWin = new Howl({ src: [playerWin], html5: false, preload: true });
        this.betrussiansnd = new Howl({ src: [betrussiansnd], html5: false, preload: true });

    }

    // resumeAudio = () => {
    //     const ctx = Howler.ctx;
    //     if (!ctx) return;
    //     // alert(ctx.state)

    //     if (ctx.state === "interrupted" || ctx.state === "suspended") {
    //         ctx.resume().then(() => {
    //             themeMusicRef.current.stop();
    //             themeMusicRef.current.play();
    //         });
    //     }
    // };


    handleKeyDown = (event) => {
        event.preventDefault();  // Disable the Tab key globally
    };


    checkChipValue(chipValue, chpTxt, i) {
        if (chipValue >= 1000) {
            chipValue = chipValue / 1000;
            this.checkChipValue(chipValue, chpTxt, i)
        } else {
            console.log(chpTxt);
            this.showResultChipValue(chipValue, chpTxt, i);
            return chipValue
        }
    }

    showResultChipValue(chVal, chipTxt, index) {
        console.log(chVal);
        console.log(chVal + "" + chipTxt)
        this.chipVal[index].label = chVal + "" + chipTxt;
        console.log(this.chipVal)
    }


    componentWillUnmount() {

        window.removeEventListener("resize", this.handleResize);
        document.removeEventListener('keydown', this.handleKeyDown);
        document.removeEventListener("visibilitychange", this.handleVisibilityChange);
         window.removeEventListener("pageshow", this.resumeAudio);

        // this.pokerchipsnd.pause();
        // this.betrussiansnd.pause();

        // this.betchipsnd.pause();
        // this.playerWin.pause();
        // this.selectCard.pause();
        // this.unselectCard.pause();
        [this.pokerchipsnd, this.betrussiansnd, this.betchipsnd, this.playerWin, this.selectCard, this.unselectCard].forEach((eachSound) => {
            if (eachSound) {
                eachSound.pause();
                eachSound.unload();
            }
        });
        this.clearallsettimeouts();

    }


    clearallsettimeouts = () => {

        this.clearTimingLeft.forEach((timeoutId) => {
            if (timeoutId) {
                clearTimeout(timeoutId)
            }
        })

        this.clearTimingLeft = [];
    }




    handleResize = () => {
        this.handleOrientationChange()
    }


    handleOrientationChange = () => {

        // Detect if the platform is Windows
        const isActiveWindowsMode =
            (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
            (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0));

        // Determine if the device is in portrait or landscape mode
        const isActivePortraitMode = window.innerHeight > window.innerWidth;
        const isActiveLandscapeMode = window.innerWidth > window.innerHeight;

        // Update the state
        this.setState({
            isActiveWindowsMode,
            isActivePortraitMode: !isActiveWindowsMode && isActivePortraitMode, // Only mobile devices will have portrait/landscape
            isActiveLandscapeMode: !isActivePortraitMode && isActiveLandscapeMode,
        });

        const blackjackBgContainerElement = document.getElementById("blackjackBgContainer");
        const blackjackTableContainerElement = document.getElementById("blackjackTableContainer");


        blackjackBgContainerElement.className = "";
        blackjackTableContainerElement.className = "";

        blackjackBgContainerElement.classList.add("backjackbg_container");

        if (isActiveWindowsMode) {
            blackjackBgContainerElement.style.backgroundImage = `url(${bjbgWnds})`;
            blackjackTableContainerElement.style.backgroundImage = `url(${bjTWnds})`;
            blackjackTableContainerElement.classList.add("backjacktable_container");


            this.setState({
                menuButton: "bjmenu_button",
                menuOption: "bj_width_for_img",
                userContainer: "bjuserContainer",
                userIcon: "bjuserContainer_img",
                userName: "bjuserContainer_span",
                balanceContainer: "bjbalanceContainer",
                betseContainer: "bjbetseContainer",
                winseContainer: "bjwinseContainer",
                informationButtonWnds: null,
                volumeButtonWnds: "bjvolumeButtonContainer",
                autoholdButton: null,
                autoplayButton: null,
                errorPopupContainer: "bjerrorPopupContainerwindows",
                userIdContainer: "bjhandIdContainer",
                useIdNumber: "bjuserContainer_span",
                betChipsContainer: "bjbetChipsContainer",
                betChipIncrementButton: "bjbetChipIncrementButton",
                betChipDecrementButton: "bjbetChipDecrementButton",
                betImageContainer: "bjbetImageContainer",
                betChipImage: "bjbetChipImage",
                betChipText: "bjbetChipText",
                betButton: null,
                dealDrawButton: "bjdealDrawButton",
                betMaxButton: "bjbetMaxButton",
                splitButton: "bjsplitButton",
                betButtonImages: "bj_width_for_img",
                gameButtonChipText: "bjgameButtonChipText",
                CardsContainer: null,
                cardsContainerCover: null,
                payoutContainer: null,
                autoplayactiveRound: null,
                menuOptionContainerCss: "bjmenuOptionContainer",
                helpMainContainer: "bjhelpMainContainer",
                rebet2Button: "bjbet2Button",
                minMaxBetLimits: "min-max-bet-limits",

                betPlaceContainer: "bjbetPlaceContainer",
                betMovingChipContainer: "bjbetMovingChipContainer bjdisplayCenterClass",
                blackjsckDeck: "blackjsckDeck",
                betChipStoreContainer: "bjbetChipStoreContainer",
                helpOption: "bjhelpOption",

            })


        } else if (!isActiveWindowsMode && isActivePortraitMode) {
            blackjackBgContainerElement.style.backgroundImage = `url(${bjbgPrt})`;
            blackjackTableContainerElement.style.backgroundImage = `url(${bjTPrt})`;
            blackjackTableContainerElement.classList.add("backjacktable_container_prt");

            this.setState({
                menuButton: "bjmenu_buttonPrt",
                menuOption: "bj_width_for_img",
                userContainer: "bjuserContainerPrt",
                userIcon: "bjuserContainer_img",
                userName: "bjuserContainer_span",
                balanceContainer: "bjbalanceContainerPrt",
                betseContainer: "bjbetseContainerPrt",
                winseContainer: "bjwinseContainerPrt",
                informationButtonWnds: null,
                volumeButtonWnds: "bjvolumeButtonContainerPrt",
                autoholdButton: null,
                autoplayButton: null,
                errorPopupContainer: "bjerrorPopupContainerwindows bjerrorPopupContainerPrt",
                userIdContainer: "bjhandIdContainerPrt",
                useIdNumber: "bjuserContainer_span",
                betChipsContainer: "bjbetChipsContainerPrt",
                betChipIncrementButton: "bjbetChipIncrementButton",
                betChipDecrementButton: "bjbetChipDecrementButton",
                betImageContainer: "bjbetImageContainer",
                betChipImage: "bjbetChipImage",
                betChipText: "bjbetChipText",
                betButton: null,
                dealDrawButton: "bjdealDrawButtonPrt",
                betMaxButton: "bjbetMaxButtonPrt",
                splitButton: "bjsplitButtonPrt",
                betButtonImages: "bj_width_for_img",
                gameButtonChipText: "bjgameButtonChipTextPrt",
                CardsContainer: null,
                cardsContainerCover: null,
                payoutContainer: null,
                autoplayactiveRound: null,
                menuOptionContainerCss: "bjmenuOptionContainerPrt",
                helpMainContainer: "bjhelpMainContainerPrt",
                rebet2Button: "bjbet2ButtonPrt",
                minMaxBetLimits: "min-max-bet-limits",

                betPlaceContainer: "bjbetPlaceContainerPrt",
                betMovingChipContainer: "bjbetMovingChipContainerPrt bjdisplayCenterClass",
                blackjsckDeck: "blackjsckDeckPrt",
                betChipStoreContainer: "bjbetChipStoreContainer",
                helpOption: "bjhelpOptionPrt",
            })




        } else if (!isActivePortraitMode && isActiveLandscapeMode) {

            blackjackBgContainerElement.style.backgroundImage = `url(${bjbgLnds})`;
            blackjackTableContainerElement.style.backgroundImage = `url(${bjTLnds})`;
            blackjackTableContainerElement.classList.add("backjacktable_container_lnds");

            this.setState({
                menuButton: 'bjmenu_buttonLnd',
                menuOption: "bj_width_for_img",
                userContainer: "bjuserContainerLnd",
                userIcon: "bjuserContainer_img",
                userName: "bjuserContainer_span",
                balanceContainer: "bjbalanceContainerLnd",
                betseContainer: "bjbetseContainerLnd",
                winseContainer: "bjwinseContainerLnd",
                informationButtonWnds: null,
                volumeButtonWnds: "bjvolumeButtonContainerLnd",
                autoholdButton: null,
                autoplayButton: null,
                errorPopupContainer: "bjerrorPopupContainerwindows",
                userIdContainer: "bjhandIdContainerLnd",
                useIdNumber: "bjuserContainer_span",
                betChipsContainer: "bjbetChipsContainerLnd",
                betChipIncrementButton: "bjbetChipIncrementButton",
                betChipDecrementButton: "bjbetChipDecrementButton",
                betImageContainer: "bjbetImageContainer",
                betChipImage: "bjbetChipImage",
                betChipText: "bjbetChipTextLnd",
                betButton: null,
                dealDrawButton: "bjdealDrawButtonLnd",
                betMaxButton: "bjbetMaxButtonLnd",
                splitButton: "bjsplitButtonLnd",
                betButtonImages: "bj_width_for_img",
                gameButtonChipText: "bjgameButtonChipTextPrt",
                CardsContainer: null,
                cardsContainerCover: null,
                payoutContainer: null,
                autoplayactiveRound: null,
                menuOptionContainerCss: "bjmenuOptionContainer",
                helpMainContainer: "bjhelpMainContainer",
                rebet2Button: "bjbe2ButtonLnd",
                minMaxBetLimits: "min-max-bet-limits min-max-bet-limits-landscape",

                betPlaceContainer: "bjbetPlaceContainerLnd",
                betMovingChipContainer: "bjbetMovingChipContainerLnd bjdisplayCenterClass",
                blackjsckDeck: "blackjsckDeck",
                betChipStoreContainer: "bjbetChipStoreContainer",
                helpOption: "bjhelpOptionLnd",
            })





        }
    }




    showPreviousGameStatus = () => {
        // check and handle gameState
        const cardsContainerCoverElement = document.getElementById("cardsContainerCover");
        // if (this.props.gameState.handId === this.props.gameState.oldHandId && this.props.gameState.handId !== undefined && this.props.gameState.response != undefined) {
        if (this.props.gameState.handId === this.props.gameState.oldHandId && this.props.gameState.handId !== undefined && this.props.gameState.response != undefined) {

            switch (this.props.gameState.response.action) {

                case "PARAM_BET":
                case "MOVE_BET":
                    this.showButtonsForNextActionfn(this.props.gameState.response);
                    setTimeout(() => {
                        this.CardsContainer.current.handleGameStateFn(this.props.gameState.response);
                    }, 100)



                    const labelAmountValue = this.topLable_rsp(this.props.gameState.response.betAmount);
                    const activeChip = this.ReturnChipBasedAmount(this.props.gameState.response.betAmount);

                    const newBetChip = {
                        chipImage: activeChip,
                        amount: labelAmountValue,
                        id: this.state.betChipsStore.length + 1,
                        className: null,
                    };

                    this.setState({
                        totalShowBetAmount: this.props.gameState.response.totalBetAmount,
                        betChipsStore: [...this.state.betChipsStore, newBetChip],
                        betAmount: this.props.gameState.response.betAmount,
                        activeHand: this.props.gameState.response.activeHand,
                        splitCount: this.props.gameState.response.splitCount,
                        betchipincrementbtn: true,
                        betchipdecreamentbtn: true,
                        isactiveGame: true,

                    }, () => {

                    })

                    break;
                default:
                    break;


            }


        } else {
            this.setState({ isactiveGame: false })
            if (this.props.gameState.response?.betAmount > 0) {
                this.showButtonsForNextRoundfu(this.props.gameState.response)

            }

        }
    }




    showHideMenuOption = () => {
        console.log("click on menu option");

        let isMenuOption = !this.state.menuOptionContainer;
        this.setState((prevState) => {
            return {
                menuOptionContainer: isMenuOption
            }

        }, () => {
            if (isMenuOption) {
                this.playRemainingSounds(this.selectCard)
                console.log(document.getElementsByClassName(".bjmenuOptionContainer button"))
                gsap.from([".bjmenuOptionContainer button", ".bjmenuOptionContainerPrt button"], {
                    x: -500,
                    duration: 0.5,
                    ease: "power2.inOut",
                    zIndex: 12,
                    autoAlpha: 1,
                    stagger: 0.3,

                });

                gsap.from([".bjhelpMainContainer", ".bjhelpMainContainerPrt"], {
                    x: 2000,
                    duration: 1,
                    ease: "power2.inOut",
                    zIndex: 12,
                    autoAlpha: 1,
                    stagger: 0.3,

                });

            } else {
                this.playRemainingSounds(this.unselectCard)
            }



        })

    }

    chooseAoptionInMenu = (option) => {
        this.playRemainingSounds(this.selectCard)
        this.setState({ activeMenuOption: option })
    }

    showDataBasedActiveMenuOption = () => {
        const { activeMenuOption } = this.state
        switch (activeMenuOption) {
            case activeMenuOptionStatus.help:
                return this.showHelpOption();
            case activeMenuOptionStatus.history:
                return this.showHistoryOption();
            default:
                return null;
        }
    }

    showHelpOption = () => (

        <div id="GameHelpContent">
            <h2>How to Play Blackjack</h2>
            <ol>
                <li>Select the chip denomination with which you would like to bet.</li>
                <li>Place your bet by clicking on <b>Place Bet</b> positions.</li>
                {/* <li>Place your bet by clicking on one or more of the <b>Place Bet</b> positions.</li> */}
                <li>Once a chip is placed, click on the initial chip/s to increase the bet.</li>
                <li>To remove all bets placed, click <b>Clear Bets</b></li>
                <li>Press <b>Deal</b> to start the hand.</li>
                <li>The dealer will be dealt 1 card, and you will be dealt 2 cards.</li>
                <li>The following standard options are available:<b>Hit</b> and <b>Stand</b>.</li>
                <li>The option to <b>Split</b> or <b>Double</b> depends on the dealt cards and appear when relevant according to the rules.</li>
                <li>The option to take <b>Insurance</b> appears when the Dealer shows an Ace.</li>
                <li>Click <b>Rebet</b> after the hand has completed to repeat your previous bet.</li>
                <li>Click <b>Rebet X2</b> after the hand has completed to double your previous bet.</li>
            </ol>
            <h2>Table Limits</h2>
            <p>The minimum and maximum bet limits apply to the initial bet only. Actions (such as split, insurance, etc. if applicable) that require an additional bet can still be used even if you placed a bet equal to the maximum bet.</p>

            <p>The 2 through 10 cards are worth their face values.</p>


            <p>J, Q and K are worth 10.</p>


            <p>The Ace has a value of either 1 or 11. If any Ace in the hand is regarded as a value of 11, the hand is referred to as "soft".</p>
            <h2>Game Rules</h2>
            <h3>General Rules</h3>
            <p>This version of Blackjack is played with 8 standard decks.</p>
            <p>The objective is to score a higher total card value than the dealer.</p>

            <ul>
                <li>If so, the player is paid at 1:1, unless the player has Blackjack in which case he is paid 3:2.</li>
                <li>If not, the player either loses the bet or, when the hands are tied, pushes.</li>
            </ul>


            <p>Players are permitted to Hit until they Bust or decide to Stand.</p>

            <p>The dealer must hit on all hands that total 16 or less, and stand on all hands that total 17 or more.</p>
            <h3>Push (Tie) Rules</h3>
            <p>The hand is considered a push if the player and the dealer tie. In the case of a push, the player's original bet is returned to him.</p>
            <h3>Blackjack Rule</h3>
            <p>If the first two cards that the player or dealer receive are an Ace and a 10 valued card, the hand is called a Blackjack.</p>
            <ul>
                <li>If the player is dealt a Blackjack, he will stand.</li>
                <li>If the dealer does not get a Blackjack, the player is paid at 3:2</li>
                <li>If the dealer is dealt a Blackjack, all hands which do not also have Blackjack lose.</li>
            </ul>
            <p>There is no offer made to take even money when the dealer has Ace showing and the player already has Blackjack.</p>
            <h3>Double Rule</h3>
            <p>Players may double on the first 2 cards of any hand.</p>
            <p>When a player doubles, his bet amount is doubled and he receives one card only.</p>
            <h3>Split Rule</h3>
            <ol>
                <li>A player may split when the hand consists of two like-value cards (for example two tens, two fours, etc).</li>
                <li>Face cards (10, Jack, Queen, King) cannot be split, regardless of whether they are the same rank or different ranks.</li>
                {/* <li>A player may not split unlike 10 value cards.</li> */}
                {/* <li>A player Can split any 10 value cards.</li> */}
                <li>When splitting Aces, only one additional card per Ace is drawn.</li>
                <li>If a player draws a 10 value card after splitting Aces, the result is considered 21 and not Blackjack.</li>
                <li>A player can split only once per hand.</li>
                <li>Double after split is allowed.</li>
            </ol>

            <h3>Insurance Rule</h3>
            <p>If the dealer's first card is an Ace, a player can choose to take insurance, placing a bet equal to half of his original bet. The insurance bet is a side bet.</p>
            <p>Insurance bets pay 2:1 if the dealer gets Blackjack. If the dealer does not get Blackjack, the player loses the insurance bet.</p>
            {/* <h3>Surrender Rule</h3>
            <p>There is no surrender option in this version of Blackjack.</p> */}

            <h2>Blackjack Terms</h2>
            <ul>
                <li>Twenty one (21) - a hand that is not a Blackjack, but totals 21.</li>
                <li>Blackjack - a hand containing an Ace and a 10 valued card.</li>
                <li>Double - the player's bet is doubled, and he receives one card only.</li>
                <li>Hit - when a player draws another card.</li>
                <li>Insurance - a side bet option only if the dealer's first card is an Ace.</li>
                <li>Push - when the player's bet is returned if hands are tied.</li>
                <li>Split - if the player is dealt two of the same cards, he can split the cards into two separate hands and the original bet is repeated on each hand.</li>
                <li>Stand - the player's request or the dealer's requirement not to be dealt any further cards.</li>
                <li>Bust - a hand that goes over a value of 21.</li>
            </ul>
            <h2>Blackjack Rules (Condensed)</h2>
            {/* <p>The rules are also available by clicking the <span class="auto-style1"><b><em>i</em></b></span> icon within the game.</p> */}
            <ul>
                <li>Played with 8 standard decks</li>
                <li>Cards are shuffled at the start of each game</li>
                <li>Dealer must stand on all 17 and above</li>
                {/* <li>No surrender</li> */}
                <li>No re-splitting</li>
                <li>One card on split aces</li>
                <li>Cannot split unlike 10 value cards</li>
                <li>Player auto-stands on 21</li>
                <li>Split Ace with 10 value card hands count as 21 - does not qualify as Blackjack</li>
            </ul>

            <section className="rtpSection">
                <h2>Return to Player</h2>
                <p>With basic strategy, the theoretical RTP of this game is 99.60%</p>
            </section>

            <h2>General Rules</h2>

            <h2>Disconnection Policy</h2>
            <p>
                <span>If connection is lost and the game action was received by the server, the game action will be processed on the server side.</span>

                <br />

                <span>If the game state is resume-able the player can continue from after their last action. If the game action was final the resulted game will be visible in Game History only.</span>

                <br />
            </p>

        </div>
    );






    showHistoryOption = () => (
        // <table id="histry_russian">
        <table>
            <thead>
                <tr>
                    <th rowSpan="2">Hand Id</th>
                    <th rowSpan="2">Dealer Cards</th>
                    <th rowSpan="2">Player Cards</th>
                    <th rowSpan="2">Dealer Score</th>
                    <th rowSpan="2">Player Score</th>

                    <th rowSpan="2">Player 1<sup>st</sup> Split Cards</th>
                    <th rowSpan="2">Player 1<sup>st</sup> Split Score</th>

                    {/* <th rowSpan="2">Player 2<sup>nd</sup> Split Cards</th>
                    <th rowSpan="2">Player 2<sup>nd</sup> Split Score</th>

                    <th rowSpan="2">Player 3<sup>rd</sup>Split Cards</th>
                    <th rowSpan="2">Player 3<sup>rd</sup>Split Score</th> */}

                    <th colSpan="2">Insurance</th>
                    <th colSpan="2">Bet Amount</th>
                    <th rowSpan="2">Double Amount</th>
                    <th rowSpan="2">Split Amount</th>
                    <th rowSpan="2">Total Bet</th>
                    <th rowSpan="2">Total Win</th>
                </tr>
                <tr>
                    <th>Wager</th>
                    <th>Win</th>
                    <th>Wager</th>
                    <th>Win</th>
                    {/* <th>Player Cards</th>
                    <th>Dealer Score</th>
                    <th>Player Score</th>
                    <th>Insurance</th>
                    <th>Bet Amount</th>
                    <th>Total Win</th> */}
                </tr>
            </thead>

            {/* <tbody id="histry_body"> */}
            <tbody>
                {this.props.gameState.history.map((obj, i) => (
                    <tr key={i}>
                        <td>{obj.handId}</td>
                        <td>
                            {obj.result.dealerCards.map((card_num, index) => {
                                const matchingCard = historyCards.find(res => res.rsc_val === card_num);
                                return (<img className="cardsimages" key={`dealer${index}`} src={matchingCard ? matchingCard.src : ''} alt={card_num} />);
                            })}
                        </td>
                        <td>
                            {obj.result.playerCards.map((card_num, index) => {
                                const matchingCard = historyCards.find(res => res.rsc_val === card_num);
                                return (<img className="cardsimages" key={`player${index}`} src={matchingCard ? matchingCard.src : ''} alt={card_num} />);
                            })}
                        </td>
                        <td>{(obj.result.dealerState === "BLACKJACK") ? obj.result.dealerState : obj.result.dealerScore}</td>
                        <td>{(obj.result.playerState === "BLACKJACK") ? obj.result.playerState : obj.result.playerScore}</td>

                        <td> {obj.result?.playerSplitFirstCards?.map((card_num, index) => {
                            const matchingCard = historyCards.find(res => res.rsc_val === card_num);
                            return (<img className="cardsimages" key={`dealerFirst${index}`} src={matchingCard ? matchingCard.src : ''} alt={card_num} />);
                        })}</td>
                        <td>{obj.result?.playerSplitFirstScore ? obj.result?.playerSplitFirstScore : ""}</td>

                        {/* <td> {obj.result?.playerSplitSecondCards?.map((card_num, index) => {
                            const matchingCard = historyCards.find(res => res.rsc_val === card_num);
                            return (<img className="cardsimages" key={index} src={matchingCard ? matchingCard.src : ''} alt={card_num} />);
                        })}</td>
                        <td>{obj.result?.playerSplitSecondScore?obj.result?.playerSplitSecondScore:""}</td>

                        <td> {obj.result?.playerSplitThirdCards?.map((card_num, index) => {
                            const matchingCard = historyCards.find(res => res.rsc_val === card_num);
                            return (<img className="cardsimages" key={index} src={matchingCard ? matchingCard.src : ''} alt={card_num} />);
                        })}</td>
                        <td>{obj.result?.playerSplitThirdScore?obj.result?.playerSplitThirdScore:""}</td> */}



                        <td>{obj.result.hasInsurance ? obj.result.insuranceBetAmount : 0}</td>
                        <td>{obj.result.hasInsurance ? obj.result.insuranceWinAmount : 0}</td>
                        <td>{obj.result.betAmount}</td>
                        <td>{obj.result.winAmount ? obj.result.winAmount : 0}</td>
                        <td>{obj.result.doubleAmount}</td>
                        <td>{obj.result.splitAmount}</td>
                        <td>{obj.result.totalBetAmount}</td>
                        <td>{obj.result.totalWinAmount}</td>

                    </tr>
                ))}

            </tbody>
        </table>
    )

    IncreamentBetchips = (BetUp = null) => {

        if (this.state.count < 5) {
            this.playPokerChipSound(this.pokerchipsnd);

            this.setState((prevState) => {
                const newCount = prevState.count + 1;
                const isMaxCount = newCount >= 5;

                return {
                    count: newCount,
                    betchipincrementbtn: isMaxCount,
                    betchipdecreamentbtn: false,
                };
            });
        }


    }

    DecreamentBetchips = (BetDown = null) => {
        if (this.state.count > 0) {
            this.playPokerChipSound(this.pokerchipsnd);

            this.setState((prevState) => {
                const newCount = prevState.count - 1;
                const isMinCount = newCount <= 0;

                return {
                    count: newCount,
                    betchipdecreamentbtn: isMinCount,
                    betchipincrementbtn: false,

                };
            });
        }



    }

    topLable_rsp = (value) => {

        const labelValue = Math.abs(Number(value));
        return labelValue >= 1.0e+9

            ? Number((labelValue / 1.0e+9).toFixed(2)) + "B"
            // Six Zeroes for Millions 
            : labelValue >= 1.0e+6

                ? Number((labelValue / 1.0e+6).toFixed(2)) + "M"
                // Three Zeroes for Thousands
                : labelValue >= 1.0e+3

                    ? Number((labelValue / 1.0e+3).toFixed(2)) + "K"

                    : Number(labelValue.toFixed(2));
    }

    ReturnChipBasedAmount = (amt) => {
        const amount = Number(amt)
        let chipImage = chip_10;
        if (Number(this.chipVal[0].val) <= amount && Number(this.chipVal[1].val) > amount) {
            chipImage = chip_10
        } else if (Number(this.chipVal[1].val) <= amount && Number(this.chipVal[2].val) > amount) {
            chipImage = chip_25
        }
        else if (Number(this.chipVal[2].val) <= amount && Number(this.chipVal[3].val) > amount) {
            chipImage = chip_50
        }
        else if (Number(this.chipVal[3].val) <= amount && Number(this.chipVal[4].val) > amount) {
            chipImage = chip_100

        } else if (Number(this.chipVal[4].val) <= amount && Number(this.chipVal[5].val) > amount) {
            chipImage = chip_500

        } else {
            chipImage = chip_1000
        }
        return chipImage
    }


    placeBet = (betPlaceType = null) => {

        if (this.props.gameState.response?.betAmount > 0) {
            // this.showButtonsForNextRoundfu(this.props.gameState.response);
            this.CardsContainer.current.clearCardsForNextRound();

        }


        console.log("bet Amount added")
        const { isActiveWindowsMode, isActivePortraitMode, isActiveLandscapeMode } = this.state;

        let tl1_x = 0;
        let tl1_y = 0;
        if (isActiveWindowsMode) {
            tl1_x = -860;
            tl1_y = -180

        } else if (isActivePortraitMode) {
            tl1_x = 10;
            tl1_y = -280;
            // tl1_x = 0;
            // tl1_y = -290;

        } else if (isActiveLandscapeMode) {
            tl1_x = -450;
            tl1_y = -25;

        }



        let newBetAmount = 0;
        if (betPlaceType === "Rebet") {

            newBetAmount = Number((this.state.balanceDeductions + this.state.rebetValue).toFixed(2));
        } else if (betPlaceType === "RebetX2") {

            newBetAmount = Number((this.state.balanceDeductions + (this.state.rebetValue * 2)).toFixed(2));
        } else {

            newBetAmount = Number((this.state.balanceDeductions + this.chipVal[this.state.count].val).toFixed(2));
        }


        const labelAmountValue = this.topLable_rsp(newBetAmount);
        const activeChip = this.ReturnChipBasedAmount(newBetAmount)
        // if (Number((this.state.betAmount + this.chipVal[this.state.count].val).toFixed(2)) <= this.props.balance) {
        console.log(Number(this.props.minBetAmt) <= newBetAmount, Number(this.props.maxBetAmt) >= newBetAmount)
        if (Number(this.props.minBetAmt) <= newBetAmount && Number(this.props.maxBetAmt) >= newBetAmount) {

            if (newBetAmount <= this.props.balance) {
                this.playPokerChipSound(this.pokerchipsnd);
                // betChipsStore


                const newBetChip = {
                    chipImage: activeChip,
                    amount: labelAmountValue,
                    id: this.state.betChipsStore.length + 1,
                    className: null,
                }

                let tl = gsap.timeline();
                tl.to("#betMovingChipContainer",
                    {
                        x: tl1_x, y: tl1_y, duration: 0.1, autoAlpha: 1, onComplete: () => {
                            this.setState((prevState) => ({
                                betChipsStore: [...prevState.betChipsStore, newBetChip],
                            }))
                        }
                    },

                )
                tl.to("#betMovingChipContainer", { x: 0, y: 0, duration: 0.0001, autoAlpha: 0 })

                this.setState((prevState) => ({
                    // betChipsStore: [...prevState.betChipsStore, newBetChip],
                    betAmount: newBetAmount,
                    balanceDeductions: newBetAmount,
                    totalShowBetAmount: newBetAmount,
                    dalStdRbetButton: "Deal",
                    dalStdRbetButtonButtonNumber: 0,
                    dalStdRbetHideShowButton: true,

                    clrHitRbetxButton: "Clear",
                    clrHitRbetx2ButtonNumber: 0,
                    clrHitRbetx2HideShowButton: true,
                    splitCount: 0,
                }))
            } else {
                this.showLowBalanceInfoPopup(`INSUFFICIENT FUNDS`, `Add Funds OR Lower Your Bet Amount.`);
            }
        } else {
            this.showLowBalanceInfoPopup(`BET LIMITS`, `${this.props.language.MinBetAmt} ${this.props.minBetAmt},  ${this.props.language.MaxBetAmt} ${this.props.maxBetAmt}.`);
        }




    }

    showLowBalanceInfoPopup = (arg1, arg2) => {
        this.setState({
            errorPopup: true,
            errorPopupTitle: arg1,
            errorPopupInfo: arg2
            // errorPopupTitle: `INSUFFICIENT FUNDS`,
            // errorPopupInfo: `Add Funds OR Lower Your Bet Amount.`
        }, () => {
            const errorPopupContainerElment = document.getElementById("errorPopupContainer");
            gsap.fromTo(errorPopupContainerElment, { scale: 0, rotate: 0, autoAlpha: 0 },
                {
                    scale: 1, duration: 1, rotate: 720, autoAlpha: 1, ease: "power2.out", onComplete: () => {

                    }
                });
        })


    }

    hidepopupContainer = () => {

        const errorPopupContainerElment = document.getElementById("errorPopupContainer");
        if (errorPopupContainerElment) {
            gsap.to(errorPopupContainerElment, {
                scale: 0,
                duration: 1,
                rotate: 0,
                opacity: 0,
                ease: "power2.out",
                continuebutton: this.state.continuebutton ? false : this.state.continuebutton,

            }
            );
            this.clearTimingLeft.push(
                setTimeout(() => {
                    this.setState({
                        errorPopup: false,
                        errorPopupTitle: "",
                        errorPopupInfo: ""
                    })
                }, 500)
            )

        }

    }


    clickOnDealButton = () => {

        if (this.state.isSoundOn) {
            // this.betrussiansnd.play();
            this.playRemainingSounds(this.betrussiansnd);
        }



        this.setState({
            dalStdRbetHideShowButton: false,
            clrHitRbetx2HideShowButton: false,
            betchipincrementbtn: true,
            betchipdecreamentbtn: true,
            isactiveGame: true,
        })


        const body = {

            sessionId: sessionStorage.getItem("sessionId"),
            CN: "BLACK_JACK_BET",
            object: {
                playerId: Number(this.props.playerId),
                gameId: Number(this.props.gameId),
                // dblBet: this.state.betAmount,
                betAmount: this.state.betAmount,
                action: "PARAM_BET",
                handId: Number(this.props.gameState.handId),
            },

        }
        console.log(body);
        this.props.network.sendof(body);

    }

    clickOnDbleHitStandFn = (strType) => {

        if (this.state.isSoundOn) {
            // this.betrussiansnd.play();
            this.playRemainingSounds(this.betrussiansnd);
        }




        let doubleAmount = 0;
        switch (strType) {
            case "DOUBLE":

                doubleAmount = Number((this.state.balanceDeductions + this.state.betAmount).toFixed(2));

                if (this.state.activeBalance >= doubleAmount) {
                    this.sendOnDbleHitStandFn(strType, doubleAmount, Number((this.state.totalShowBetAmount + this.state.betAmount).toFixed(2)));
                } else {
                    this.showLowBalanceInfoPopup(`INSUFFICIENT FUNDS`, `Add Funds OR Lower Your Bet Amount.`);
                }


                break;
            case "SPLIT":
                doubleAmount = Number((this.state.balanceDeductions + this.state.betAmount).toFixed(2));

                if (this.state.activeBalance >= doubleAmount) {
                    const { splitCount } = this.state
                    const activeSplitCount = splitCount + 1;
                    this.sendOnDbleHitStandFn(strType, doubleAmount, Number((this.state.totalShowBetAmount + this.state.betAmount).toFixed(2)), activeSplitCount);
                    this.setState({ splitCount: activeSplitCount, })
                } else {
                    this.showLowBalanceInfoPopup(`INSUFFICIENT FUNDS`, `Add Funds OR Lower Your Bet Amount.`);
                }


                break;
            case "INSURANCE_YES":
                let insuranceAmount = 0;
                if (this.state.hasInsurance) {
                    insuranceAmount = Number((this.state.balanceDeductions + this.state.insuranceBetAmount).toFixed(2));
                }

                if (this.state.activeBalance >= insuranceAmount) {
                    this.sendOnDbleHitStandFn(strType, insuranceAmount, Number((this.state.totalShowBetAmount + this.state.insuranceBetAmount).toFixed(2)));
                } else {
                    this.showLowBalanceInfoPopup(`INSUFFICIENT FUNDS`, `Add Funds OR Lower Your Bet Amount.`);
                }

                break;


            default:
                this.sendOnDbleHitStandFn(strType, this.state.balanceDeductions, this.state.totalShowBetAmount)
                break;
        }


    }

    sendOnDbleHitStandFn = (strType, currentBetValue, totalShowBetAmount, activeSplitCount = this.state.splitCount) => {
        if (strType === "DOUBLE" || strType === "INSURANCE_YES" || strType === "SPLIT") {

            const { isActiveWindowsMode, isActivePortraitMode, isActiveLandscapeMode } = this.state;

            let tl1_x = 0;
            let tl1_y = 0;

            if (isActiveWindowsMode) {
                tl1_x = -860;
                tl1_y = -180

            } else if (isActivePortraitMode) {
                tl1_x = 10;
                tl1_y = -280;
                // tl1_x = 0;
                // tl1_y = -290;

            } else if (isActiveLandscapeMode) {
                tl1_x = -450;
                tl1_y = -25;

            }

            const labelAmountValue = this.topLable_rsp(totalShowBetAmount);
            const activeChip = this.ReturnChipBasedAmount(totalShowBetAmount);

            let tl = gsap.timeline();
            tl.to("#betMovingChipContainer",
                {
                    x: tl1_x, y: tl1_y, duration: 0.1, autoAlpha: 1, onComplete: () => {
                    }
                },

            )
            tl.to("#betMovingChipContainer", { x: 0, y: 0, duration: 0.0001, autoAlpha: 0 })

            const newBetChip = {
                chipImage: activeChip,
                amount: labelAmountValue,
                id: this.state.betChipsStore.length + 1,
                className: null,
            }
            this.setState((prevState) => ({
                betChipsStore: [...prevState.betChipsStore, newBetChip],
            }))
        }


        this.setState({
            balanceDeductions: currentBetValue,
            totalShowBetAmount: totalShowBetAmount,
            dalStdRbetButton: "Stand",
            dalStdRbetButtonButtonNumber: 1,
            dalStdRbetHideShowButton: false,

            clrHitRbetxButton: "Hit",
            clrHitRbetx2ButtonNumber: 1,
            clrHitRbetx2HideShowButton: false,

            doubleHideShowButton: false,
            splitHideShowButton: false
        })
        const body = {

            sessionId: sessionStorage.getItem("sessionId"),
            CN: "BLACK_JACK_BET",
            object: {
                playerId: Number(this.props.playerId),
                gameId: Number(this.props.gameId),
                handId: Number(this.props.gameState.handId),
                // strType: "DOUBLE",
                strType: strType,
                action: "MOVE_BET",
                splitCount: activeSplitCount,
                activeHand: this.state.activeHand
            },

        }
        this.props.network.sendof(body);

    }

    updatePlayerBalance = () => {

        const body = {
            CN: "GET_PLAYER_INFO",
            sessionId: sessionStorage.getItem("sessionId"),
            object: {
                gameId: Number(this.props.gameId),
                playerId: Number(this.props.playerId),
            },
        };


        this.props.network.sendof(body);
        this.body = {};
    };

    updateHistory = () => {

    }

    updateMessage = () => {
        this.showLowBalanceInfoPopup(`ERROR INFO`, this.props.infoText);
    }




    dealBetResultRes = (result) => {

        // const winpopupElement = document.getElementById("winpopupBlackjack");
        // const winamtSpanElement = document.getElementById("winpopupBlackjackSpan");


        this.CardsContainer.current.blackjacksRespose(result);
        const dealerCardLength = result.playerCards.length;
        const playerCardsLength = result.dealerCards.length;
        let showButtonDuration = (((dealerCardLength > playerCardsLength ? dealerCardLength : playerCardsLength) + 1) * 500);


        if ((Number(result.totalWinAmount) > 0) && result.gameFinished) {

            this.clearTimingLeft.push(
                setTimeout(() => {
                    this.playRemainingSounds(this.playerWin)
                    this.setState({ blackJackWinamount: result.totalWinAmount });
                    this.winPopupContainer.current.showWinAnimationAndMinAmount(result.totalWinAmount);

                }, showButtonDuration)
            )

            this.clearTimingLeft.push(
                setTimeout(() => {
                    // this.showButtonsForNextRoundfu(result);
                    this.clearTimingLeft.push(
                        setTimeout(() => {
                            this.updatePlayerBalance();
                            this.props.gamstateHandle();
                            this.clearallsettimeouts();

                        }, 100)
                    )


                }, showButtonDuration + 4000)
            )
        } else if ((result.totalWinAmount === 0) && (result.winner === "Dealer") && result.gameFinished) {
            this.clearTimingLeft.push(
                setTimeout(() => {
                    // this.playRemainingSounds(this.playerWin)
                    // this.showButtonsForNextRoundfu(result);
                    this.clearTimingLeft.push(
                        setTimeout(() => {
                            this.updatePlayerBalance();
                            this.props.gamstateHandle();
                            this.clearallsettimeouts();

                        }, 100)
                    )
                }, showButtonDuration)
            )

        } else {

            this.clearTimingLeft.push(
                setTimeout(() => {
                    this.showButtonsForNextActionfn(result);
                    const nextHand = 0
                    // if((result.splitCount >0)&&((dealerState ==="WIN" || playerState ==="LOST"))){
                    this.setState({ activeHand: result.activeHand })

                    // }
                }, showButtonDuration)
            )
        }



    }

    showButtonsForNextRoundfu = (result) => {

        this.setState({
            dalStdRbetButton: "Rebet",
            dalStdRbetButtonButtonNumber: 2,
            dalStdRbetHideShowButton: true,

            clrHitRbetxButton: "RebetX2",
            clrHitRbetx2ButtonNumber: 2,
            clrHitRbetx2HideShowButton: true,

            doubleHideShowButton: false,

            rebetValue: result.betAmount,
            balanceDeductions: 0,
            totalShowBetAmount: 0,
            betAmount: 0,
            blackJackWinamount: 0,
            hasInsurance: false,
            insuranceBetAmount: 0,
            betChipsStore: [],
            activeHand: 0,
            // splitCount: 0,
            betchipincrementbtn: this.state.count >= 5 ? true : false,
            betchipdecreamentbtn: this.state.count <= 0 ? true : false,
            isactiveGame: false,

        });

        // this.CardsContainer.current.clearCardsForNextRound();




    }

    allowPlaceBetForNextRound = (res) => {
        this.showButtonsForNextRoundfu(res?.response)

    }

    showButtonsForNextActionfn = (response) => {
        switch (response.message) {
            case "Hit/Stand/Double/Split":
                this.setState({
                    dalStdRbetButton: "Stand",
                    dalStdRbetButtonButtonNumber: 1,
                    dalStdRbetHideShowButton: true,

                    clrHitRbetxButton: "Hit",
                    clrHitRbetx2ButtonNumber: 1,
                    clrHitRbetx2HideShowButton: true,

                    doubleHideShowButton: true,

                    splitHideShowButton: true,

                })
                break;
            case "Hit/Stand/Double":
                this.setState({
                    dalStdRbetButton: "Stand",
                    dalStdRbetButtonButtonNumber: 1,
                    dalStdRbetHideShowButton: true,

                    clrHitRbetxButton: "Hit",
                    clrHitRbetx2ButtonNumber: 1,
                    clrHitRbetx2HideShowButton: true,

                    doubleHideShowButton: true
                })
                break
            case "Hit/Stand":
                this.setState({
                    dalStdRbetButton: "Stand",
                    dalStdRbetButtonButtonNumber: 1,
                    dalStdRbetHideShowButton: true,

                    clrHitRbetxButton: "Hit",
                    clrHitRbetx2ButtonNumber: 1,
                    clrHitRbetx2HideShowButton: true,

                    doubleHideShowButton: false
                })
                break;
            case "Insurance":
                this.setState({
                    dalStdRbetButton: "Insurance",
                    dalStdRbetButtonButtonNumber: 3,
                    dalStdRbetHideShowButton: true,

                    clrHitRbetxButton: "NoInsurance",
                    clrHitRbetx2ButtonNumber: 3,
                    clrHitRbetx2HideShowButton: true,
                    hasInsurance: response.hasInsurance,
                    insuranceBetAmount: response.insuranceBetAmount
                })
                break
            case `You have ${response.playerScore}. Half of your bet for Insurance: 0.75. Press No Insurance to continue without Insurance.`:
                this.setState({
                    dalStdRbetButton: "Insurance",
                    dalStdRbetButtonButtonNumber: 3,
                    dalStdRbetHideShowButton: true,

                    clrHitRbetxButton: "NoInsurance",
                    clrHitRbetx2ButtonNumber: 3,
                    clrHitRbetx2HideShowButton: true,
                })
                break
            default:
                break;

        }
    }






    updatePlayerInfo = (event) => {
        this.setState({
            activeBalance: Number(event.balance),
            // activeBalance: 1,
            balanceDeductions: 0,
        })

    }

    clickOnClearFn = () => {
        if (this.state.isSoundOn) {
            // this.betrussiansnd.play();
            this.playRemainingSounds(this.betrussiansnd);
        }
        this.updatePlayerBalance()

        this.setState((prevState) => ({
            betChipsStore: [],
            betAmount: 0,
            balanceDeductions: 0,
            totalShowBetAmount: 0,
            dalStdRbetHideShowButton: false,
            clrHitRbetx2HideShowButton: false,
        }))
    };

    callSoundButton = () => {

        Howler?.mute(this.state.isSoundOn);
        this.playRemainingSounds(this.selectCard);
        this.setState((prevstate) => ({
            isSoundOn: !prevstate.isSoundOn,
        }))
    }

    handleImageLoad = () => {
        const { assestsLoaderFunction } = this.props;
        assestsLoaderFunction();
    }


    closeWin() {
        document.getElementById('iospopup').style.display = "none";

    }


    render() {

        const { count, dalStdRbetHideShowButton, balanceDeductions, totalShowBetAmount, activeBalance,
            activeMenuOption, isSoundOn, playerHand, betChipsStore, blackJackWinamount, isActiveWindowsMode,
            isActivePortraitMode, isActiveLandscapeMode, activeHand, splitCount, splitHideShowButton, doubleHideShowButton, isactiveGame } = this.state;

        const { src, val, label } = this.chipVal[count]

        const currentBalace = Number((activeBalance - balanceDeductions).toFixed(2));

        let helpOption = activeMenuOption === activeMenuOptionStatus.help ? "bjbackgroundColor" : "borderColor";
        let historyOption = activeMenuOption === activeMenuOptionStatus.history ? "bjbackgroundColor" : "borderColor";

        return (
            <div id="blackjackBgContainer">

                <div className="iosFetchSounds" id="iospopup" onClick={(e) => this.closeWin()}>
                    <div className="popupTooLong">
                        <div className=""> {this.props.language.Wel_BK} </div>
                        <br></br>
                        {this.props.language.OK_Btn}
                        <br></br>
                        <div className="fd">
                            <button className="btn_iosPopup" onClick={(e) => this.closeWin()}> {this.props.language.Ok} </button>
                            <br></br>
                        </div>
                    </div>
                </div>

                <button type="button" id="menuButton" className={this.state.menuButton} onClick={this.showHideMenuOption}>
                    <img id="menuIcon" className={this.state.menuOption} src={menuImg} alt="menuOption" />
                </button>

                <div id="balanceContainer" className={this.state.balanceContainer}>
                    <img id="balanceIcon" className={this.state.userIcon} src={balanceImg} alt="balanceIcon" />
                    <span id="currentBalance" className={this.state.useIdNumber}>{currentBalace}</span>
                </div>

                <div id="betContainer" className={this.state.betseContainer}>
                    <img id="betIcon" className={this.state.userIcon} src={betImg} alt="betIcon" />
                    <span id="currentBet" className={this.state.useIdNumber}>{Number(totalShowBetAmount.toFixed(2))}</span>
                </div>

                <div id="winContainer" className={this.state.winseContainer}>
                    <img id="winIcon" className={this.state.userIcon} src={winImg} alt="winImage" />
                    <span id="currentWin" className={this.state.useIdNumber}>{blackJackWinamount}</span>
                </div>

                <div id="userContainer" className={this.state.userContainer}>
                    <img id="userIcon" className={this.state.userIcon} src={usernameImg} alt="userIcon" />
                    <span id="currentUserName" className={this.state.userName}>{this.props.user}</span>
                </div>

                <div id="handIdContainer" className={this.state.userIdContainer}>
                    {/* <p>P ID : <span id="" className={this.state.useIdNumber}>{this.props.playerId}</span></p>
                    <p>ID : <span id="" className={this.state.useIdNumber}>{this.props.gameState.handId}</span></p> */}
                    <p>P ID : <span id="" >{this.props.playerId}</span></p>
                    <p>ID : <span id="">{this.props.gameState.handId}</span></p>
                </div>

                <div className={this.state.minMaxBetLimits}>
                    <span>Min:{this.props.minBetAmt}</span>
                    <span>Max:{this.props.maxBetAmt}</span>

                </div>

                <button type="button" id="volumeButton" className={this.state.volumeButtonWnds} onClick={this.callSoundButton}>
                    <img id="volumeIcon" className={this.state.userIcon} src={isSoundOn ? volumeImg : mutesnds} alt="volumeImg" />
                </button>

                <img className={this.state.blackjsckDeck} src={blackjsckDeck} alt="blackjsckDeck" />


                <div id="blackjackTableContainer" onLoad={this.handleImageLoad}>
                    <button id="placeBetButtonBJ" className={this.state.betPlaceContainer}
                        role="button" onClick={(e) => { e.preventDefault(); this.placeBet() }} disabled={isactiveGame}
                    //  tabIndex={0} 
                    >
                        <img className={this.state.betChipImage} src={placeBetImg} alt="placeBetImg" />
                        <span>Place Bet</span>
                        {betChipsStore.map(({ chipImage, amount, id, className }, index) => {
                            return (
                                <div className={this.state.betChipStoreContainer} key={id || index}>
                                    <img className={this.state.betChipImage} src={chipImage} alt={`Chip worth${amount}`} />
                                    <span id="bkbetspan" className={this.state.betChipText}>{amount}</span>
                                </div>
                            )
                        })}

                        {/* <div id="winpopupBlackjack">
                            <span id="winpopupBlackjackSpan">{blackJackWinamount ? blackJackWinamount : ""}</span>
                        </div> */}
                    </button>

                    <CardsContainer ref={this.CardsContainer}
                        isActiveWindowsMode={isActiveWindowsMode}
                        isActivePortraitMode={isActivePortraitMode}
                        isActiveLandscapeMode={isActiveLandscapeMode}
                        splitCount={splitCount}
                        activeHand={activeHand}
                        isSoundOn={isSoundOn}

                    />

                    {dalStdRbetHideShowButton &&
                        <button className={this.state.dealDrawButton} type="button" id="dealDrawButton"
                            onClick={(e) => {
                                e.preventDefault();
                                if (this.state.dalStdRbetButtonButtonNumber === 0) {
                                    this.clickOnDealButton();
                                } else if (this.state.dalStdRbetButtonButtonNumber === 1) {
                                    // this.clickOnStantButton();
                                    this.clickOnDbleHitStandFn("STAND")
                                } else if (this.state.dalStdRbetButtonButtonNumber === 2) {
                                    this.placeBet("Rebet");
                                } else if (this.state.dalStdRbetButtonButtonNumber === 3) {
                                    this.clickOnDbleHitStandFn("INSURANCE_YES");
                                }
                            }}>
                            <img className={this.state.betButtonImages} src={dealbtnWds} alt="" />
                            <p className={this.state.gameButtonChipText}>
                                {this.state.dalStdRbetButtonButtonNumber === 0 ? this.props.language.Deal :
                                    this.state.dalStdRbetButtonButtonNumber === 1 ? this.props.language.Stand :
                                        this.state.dalStdRbetButtonButtonNumber === 2 ? this.props.language.Rebet :
                                            this.props.language.Insurence}</p>
                        </button>
                    }

                    {this.state.clrHitRbetx2HideShowButton &&
                        (<button className={this.state.rebet2Button} type="button" onClick={() => {

                            if (this.state.clrHitRbetx2ButtonNumber === 0) {
                                this.clickOnClearFn();
                            } else if (this.state.clrHitRbetx2ButtonNumber === 1) {
                                this.clickOnDbleHitStandFn("HIT")
                            } else if (this.state.clrHitRbetx2ButtonNumber === 2) {
                                this.placeBet("RebetX2")
                            } else if (this.state.clrHitRbetx2ButtonNumber === 3) {
                                this.clickOnDbleHitStandFn("INSURANCE_NO")

                            }
                        }}>

                            <img className={this.state.betButtonImages} src={clearbtnWds} alt="" />
                            <p className={this.state.gameButtonChipText} >
                                {this.state.clrHitRbetx2ButtonNumber === 0 ? this.props.language.RP_Clear :
                                    this.state.clrHitRbetx2ButtonNumber === 1 ? this.props.language.Hit :
                                        this.state.clrHitRbetx2ButtonNumber === 2 ? this.props.language.Rebet_X2 :
                                            this.props.language.No_Insurence}</p>
                        </button>)}

                    {doubleHideShowButton &&
                        (<button className={this.state.betMaxButton} type="button" onClick={() => { this.clickOnDbleHitStandFn("DOUBLE") }}>
                            <img className={this.state.betButtonImages} src={doublebtnWds} alt="" />
                            <p className={this.state.gameButtonChipText}>{this.props.language.Double_bk}</p>
                        </button>)}


                    {splitHideShowButton &&
                        (<button type="button" className={this.state.splitButton} onClick={() => { this.clickOnDbleHitStandFn("SPLIT") }}>
                            <img className={this.state.betButtonImages} src={splitbtnWds} alt="" />
                            <p className={this.state.gameButtonChipText}>{this.props.language.Split}</p>
                        </button>)
                    }

                </div>


                <div id="betMovingChipContainer" className={this.state.betMovingChipContainer}>
                    <img className={this.state.betButtonImages} src={src} alt={`current_chip_value${src}`} />
                    <span className={this.state.betChipText}>{label}</span>
                </div>


                <div id="betchipsContainer" className={this.state.betChipsContainer}>
                    {this.state.betChipsCover && (
                        <div className="betChipscoverContainer"></div>
                    )}
                    <button className={this.state.betChipIncrementButton} disabled={this.state.betchipdecreamentbtn}>
                        <img className={this.state.menuOption} src={betincerementdecrement} id="betincrenet" onClick={(e) => { e.preventDefault(); this.DecreamentBetchips(); }} alt="" />
                    </button>

                    <div id="bjactiveChip" className={this.state.betImageContainer}>
                        <img className={this.state.betChipImage} src={src} id="betchips" alt="" />
                        <span id="" className={this.state.betChipText}>{label}</span>
                    </div>

                    <button className={this.state.betChipDecrementButton} disabled={this.state.betchipincrementbtn}>
                        <img className={this.state.menuOption} src={betincerementdecrement} id="betdecrement" onClick={(e) => { e.preventDefault(); this.IncreamentBetchips(); }} alt="" />
                    </button>
                </div>
                <CoinBurst ref={this.winPopupContainer} />
                {this.state.menuOptionContainer && (
                    <>
                        <div className="bjcoverContainer" onClick={this.showHideMenuOption}> </div>
                        <div className={this.state.menuOptionContainerCss}>
                            <button type="button" className={helpOption} onClick={() => { this.chooseAoptionInMenu(activeMenuOptionStatus.help) }}>HELP</button>
                            <button type="button" className={historyOption} onClick={() => { this.chooseAoptionInMenu(activeMenuOptionStatus.history) }}>HISTORY</button>
                        </div>

                        <div className={this.state.helpMainContainer}>
                            {this.showDataBasedActiveMenuOption()}
                        </div>

                    </>

                )

                }

                {this.state.errorPopup && (
                    <div className="bjcoverContainer">
                        <div id="errorPopupContainer" className={this.state.errorPopupContainer}>
                            <button className="errorPopupExitIcon" id="exitPopup" onClick={this.hidepopupContainer}><img src={popupExit} alt={popupExit} /></button>
                            <h4 className="errorPopupTitle">{this.state.errorPopupTitle}</h4>
                            <h2 className="errorPopupInfo">
                                {this.state.errorPopupInfo}
                            </h2>
                            {/* {this.state.continuebutton && <button type="button" className="autoplayContinue"
                                onClick={() => {
                                    this.afterBalancCheckplayingAutoPlay(this.autoPlayContinueCount);
                                    this.hidepopupContainer()

                                }}>continue</button>} */}
                        </div>
                    </div>
                )}

            </div>
        )
    }
}

const mapStatesToProps = (state) => {
    return {
        language: state.languageObjs.languageObj
    }
}
export default connect(mapStatesToProps)(BlackJack)

// export default BlackJack